import * as React from "react";
import axios from "axios";

import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import {
  AuthContext,
  DialogContext,
  JoySnackBarContext,
  TranslationContext,
} from "./context";
import { useNavigate } from "react-router-dom";
import LanguageDropdown from "./LangugageSelect";

const config = require("../config/config");

function ResponsiveAppBar() {
  const navigate = useNavigate();
  const { authState, AuthDispatcher } = React.useContext(AuthContext);
  const { DialogDispatcher } = React.useContext(DialogContext);
  const { JoySnackBarDispatcher } = React.useContext(JoySnackBarContext);

  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);

  const [pages, setPages] = React.useState(["AI Kundali", "Support"]);

  const [menu, setMenu] = React.useState(["Log In", "Sign Up"]);

  React.useEffect(() => {
    console.log(authState);

    if (!authState.role) {
      setPages(["AI Kundali", "About", "Theory", "Project AstroData"]);
      setMenu(["Log In", "Sign Up"]);
    }

    if (authState.role === "user") {
      setPages([
        "AI Kundali",
        "Saved Charts",
        "Purchase History",
        "Support",
        "About",
        "Theory",
      ]);
      setMenu(["Profile", "Account", "Logout"]);
    }

    if (authState.role === "admin") {
      setPages([
        "Dashboard",
        "All Charts DB",
        "Urgent Requests",
        "Users",
        "AI Kundali",
        "Theory",
      ]);
      setMenu(["Admin Settings", "Profile", "Account", "Logout"]);
    }
  }, [authState]);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleSignOut = async () => {
    try {
      const response = await axios.post(
        `${config.baseURL}/auth/logout`,
        {},
        {
          headers: {
            Authorization: `Bearer ${authState.token}`,
          },
        }
      );

      console.log("API Response:", response.data);

      AuthDispatcher("LOGGED-OUT");

      JoySnackBarDispatcher("OPEN", {
        vertical: "top",
        horizontal: "right",
        message: response.data.snackAlertMessage,
        color: "success",
        size: "md",
        variant: "soft",
        iconName: "LoginSuccessful",
        iconColor: "success",
      });
    } catch (error) {
      console.error("Error during sign out:", error);

      if (error.response.status === 401) {
        console.log(error.response.data.dialogueAlertMessage);
        console.log(error.response.data.snackAlertMessage);

        JoySnackBarDispatcher("OPEN", {
          vertical: "top",
          horizontal: "right",
          message: error.response.data.snackAlertMessage
            ? error.response.data.snackAlertMessage
            : "Something went wrong or No internet. Please try again later",
          color: "warning",
          size: "md",
          variant: "soft",
          iconName: "LogOutError",
          iconColor: "warning",
        });
      } else {
        AuthDispatcher("LOGGED-OUT");
      }
    }
  };

  const handleMenuItemClick = (page) => {
    switch (page) {
      case "AI Kundali":
        console.log("AI Kundali clicked");
        navigate("/interactive-kundali");
        break;

      case "About":
        console.log("About clicked");
        navigate("/about");
        break;

      case "Saved Charts":
        console.log("About clicked");
        navigate("/saved-charts");
        break;

      case "Purchase History":
        console.log("About clicked");
        navigate("/purchase-history");
        break;

      case "Support":
        console.log("About clicked");
        navigate("/support");
        break;

      case "Dashboard":
        console.log("About clicked");
        navigate("/dashboard");
        break;

      case "All Charts DB":
        console.log("About clicked");
        navigate("/all-charts-db");
        break;

      case "Urgent Requests":
        console.log("About clicked");
        navigate("/urgent-requests");
        break;

      case "Users":
        console.log("About clicked");
        navigate("/user-list");
        break;

      case "Theory":
        console.log("Theory clicked");
        navigate("/theory");
        break;

      case "Project AstroData":
        console.log("Project AstroData clicked");
        navigate("/project-astrodata");
        break;

      default:
        console.log("Unknown menu item clicked");
      // Handle unknown option
    }
  };

  const handleProfileOptionClick = (setting) => {
    switch (setting) {
      case "Profile":
        // Logic for handling Profile click
        console.log("Profile clicked");

        navigate("/profile");

        break;
      case "Account":
        // Logic for handling Account click
        console.log("Account clicked");
        navigate("/account");

        break;
      case "Logout":
        // Logic for handling Logout click
        console.log("Logout clicked");

        handleSignOut();
        // Add your specific logic here
        break;
      case "Log In":
        // Logic for handling Log In click
        console.log("Log In clicked");

        DialogDispatcher("OPEN", { login: true });

        break;
      case "Sign Up":
        // Logic for handling Sign Up click
        console.log("Sign Up clicked");

        DialogDispatcher("OPEN", { signup: true });

        // Add your specific logic here
        break;

      case "Admin Settings":
        console.log("Admin Settings clicked");

        navigate("/admin-settings");
        break;
      default:
        console.log("Unknown option clicked");
      // Handle unknown option
    }
  };

  const t = React.useContext(TranslationContext);

  return (
    <AppBar position="static" sx={{ marginBottom: "3vh" }}>
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Brightness4Icon
            sx={{ display: { xs: "none", md: "flex" }, mr: 1 }}
          />
          <Typography
            variant="h6"
            noWrap
            component="a"
            href="/"
            sx={{
              mr: 2,
              display: { xs: "none", md: "flex" },
              fontFamily: "courier new",
              fontWeight: 900,
              letterSpacing: ".2rem",
              color: "inherit",
              textDecoration: "none",
            }}
          >
            AstroData
          </Typography>

          <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: "block", md: "none" },
              }}
            >
              {pages.map((page) => (
                <MenuItem key={page} onClick={() => handleMenuItemClick(page)}>
                  <Typography textAlign="center">{page}</Typography>
                </MenuItem>
              ))}
              <MenuItem>
                <LanguageDropdown />
              </MenuItem>
            </Menu>
          </Box>
          <Brightness4Icon
            sx={{ display: { xs: "flex", md: "none" }, mr: 1 }}
          />

          <Typography
            variant="h5"
            noWrap
            component="a"
            // href="#app-bar-with-responsive-menu"
            sx={{
              mr: 2,
              display: { xs: "flex", md: "none" },
              flexGrow: 1,
              fontFamily: "courier new",
              fontWeight: 900,
              letterSpacing: ".2rem",
              color: "inherit",
              textDecoration: "none",
            }}
          >
            AstroData
          </Typography>
          <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
            {pages.map((page) => (
              <Button
                key={page}
                onClick={() => handleMenuItemClick(page)}
                sx={{ my: 2, color: "white", display: "block" }}
              >
                {page}
              </Button>
            ))}
          </Box>

          <Box
            sx={{
              display: { xs: "none", md: "flex" },
              alignItems: "center",
              marginRight: 4,
              padding: 2,
            }}
          >
            <LanguageDropdown />
          </Box>

          <Box sx={{ flexGrow: 0 }}>
            <Tooltip title="Open menu">
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <Avatar
                  alt="Remy Sharp"
                  src="https://t3.ftcdn.net/jpg/01/18/01/98/360_F_118019822_6CKXP6rXmVhDOzbXZlLqEM2ya4HhYzSV.jpg"
                />
              </IconButton>
            </Tooltip>
            <Menu
              sx={{ mt: "45px" }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {menu.map((setting) => (
                <MenuItem
                  key={setting}
                  onClick={() => {
                    handleProfileOptionClick(setting);
                    handleCloseUserMenu();
                  }}
                >
                  <Typography textAlign="center">{setting}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default ResponsiveAppBar;
